import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import moment from "moment";
import React, { useEffect } from "react";
import ColourField from "../common/colour.field";
import DateField from "../common/date.field";
import { useForm } from "../common/form.util";

export default function StudentForm(props) {
	const formCtx = useForm(props.student, props);
	let student = formCtx?.data;

	useEffect(() => {
		formCtx.setData(props.student);
	}, [props.student]);

	let birthDate = student?.birthDate ? moment(student.birthDate) : null;

	return (
		<Stack direction="column" sx={props.sx}>
			<TextField label="Name" variant="standard" value={student?.name || ''} onChange={(e) => formCtx.onChange(e, 'name')} required autoFocus />
			{!props.required &&
				<React.Fragment>
					<ColourField label="Favourite Colour" variant="standard" value={student?.colour || ''} onChange={(e) => formCtx.onChange(e, 'colour')} />
					<DateField label="Birthday" variant="standard" value={birthDate} onChange={(e) => formCtx.onChange(e, 'birthDate')} views={['year', 'month', 'day']} openTo="year" />
				</React.Fragment>
			}
		</Stack>
	);
}